import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { blogPosts } from './blogPosts.generated';
import { absoluteUrl, descriptionFromBody, setPageMeta } from './pageMeta';
import './Marketing.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  useEffect(() => {
    if (!post) {
      setPageMeta({
        title: 'Post not found — Racontera',
        description: 'The blog post you requested could not be found.',
        path: `/blog/${slug || ''}`,
        ogType: 'website',
        schema: 'WebPage',
      });
      return;
    }
    const description = (post.excerpt || '').trim() || descriptionFromBody(post.body);
    const published = post.date ? `${post.date}T00:00:00.000Z` : undefined;
    const image = post.image
      ? post.image.startsWith('http')
        ? post.image
        : absoluteUrl(post.image.startsWith('/') ? post.image : `/${post.image}`)
      : undefined;
    setPageMeta({
      title: `${post.title} — Racontera`,
      description,
      path: `/blog/${post.slug}`,
      ogType: 'article',
      headline: post.title,
      datePublished: published,
      dateModified: published,
      image,
      schema: 'BlogPosting',
      author: post.author || null,
    });
  }, [post, slug]);

  if (!post) {
    return (
      <div className="blog-post-not-found">
        <h1>Post not found</h1>
        <p>
          <Link to="/blog" className="blog-post-back">
            Back to blog
          </Link>
        </p>
      </div>
    );
  }

  return (
    <article className="blog-post">
      <Link to="/blog" className="blog-post-back">
        ← Back to blog
      </Link>
      <h1>{post.title}</h1>
      <div className="blog-post-meta">{formatDate(post.date)}</div>
      <div className="blog-post-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.body}</ReactMarkdown>
      </div>
    </article>
  );
}

export default BlogPost;
